<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <v-card class="dialog">
      <v-card-title class="primary amber blue-grey--text text--darken-4">
        <span class="headline">留学先国の変更</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid">
            <v-row dense>
              <v-col cols="12">
                <v-select required
                  v-model="form.country"
                  label="留学先の国"
                  item-text="text"
                  item-value="value"
                  :items="getNationItems"
                  :rules="rules.country"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field required
                  v-model="form.city"
                  label="留学先の都市"
                  :rules="rules.city"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorProgsModalsTitle',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        country: '',
        city: ''
      },
      rules: {
        country: [
          v => !!v || '必須項目です'
        ],
        city: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item', {
            id: this.form.id,
            country: this.form.country,
            city: this.form.city
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', res.data.data)
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, country, city } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        country: country,
        city: city
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).filter(key => {
        return key !== 'JP'
      }).map(key => {
        return {
          text: this.$mango.nations[key],
          value: key
        }
      })
    }
  }
}
</script>
